module.exports = __webpack_public_path__ + "static/media/cropped-logo.ca589a42.png";